<template>
    <div class="driver-component">
       <div class="main-container-form">
        <section class="head-title clearfix">
          <div class="titleForm-container">物流信息</div>
          <div class="add" v-if="canEdit" @click="add('logistics')">
            <img src="../../../assets/images/qualityTracing/nav_add.png" alt="">
            <span>添加</span>
          </div>
        </section>
        <el-form :id="'driver'+index" v-for="(item,index) in logistics" :key="index" :model="item" :rules="rules" ref="baseForm" label-width="100px">
          <span v-if="canEdit" @click="del('logistics',index)" class="delete">删除</span>
          <el-form-item label="姓   名" prop="name">
            <el-select v-model="item.name" placeholder="请选择" size="medium" style="width:100%;" @change="changeDriver($event,index)">
              <el-option v-for="list in driverKeyValue" :key="list.id" :label="list.value" :value="list.key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input v-model="item.phone" :disabled="true" size="medium" style="width:100%;" placeholder="请输入联系电话" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num20">
            </el-input>
          </el-form-item>
          
          <div class="two-row">
            <el-form-item label="车牌号">
              <el-input v-model="item.carNo" :disabled="true" size="medium" style="width:100%;" placeholder="请输入车牌号" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num20">
              </el-input>
            </el-form-item>
            <el-form-item label="道路运输证" class="txc">
              <el-input v-model="item.driverNo" :disabled="true" size="medium" style="width:100%;" placeholder="请输入道路运输证号" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num20">
              </el-input>
            </el-form-item>
          </div>
          <el-form-item  label="出发时间" prop="name" class="time">
            <el-date-picker
             v-model="item.startDate"
              type="datetime"
              :clearable="false"
              style="width: 100%;"
              placeholder="选择出发时间"
              @input="transData(index)"
              default-time="12:00:00"
             >
            </el-date-picker>
            
          </el-form-item>
          <el-form-item  label="到达时间" prop="name" class="time">
            <el-date-picker
              v-model="item.endDate"
              type="datetime"
              style="width: 100%;"
              :clearable="false"
              placeholder="选择到达时间"
              @input="transData(index)"
              default-time="12:00:00"
              >
            </el-date-picker>
          </el-form-item>
          <el-row :gutter="5">
            <el-form-item label="起始地" required class="addr">
              <el-col :span="8">
                <el-form-item prop="provinceNo">
                  <el-select v-model="baseForm[index].provinceNo" placeholder="请选择省份" size="medium" style="width:160px" @change="selectProvince($event,index)"  >
                    <el-option v-for="item in provinces" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="cityNo" v-if=" baseForm[index].citys.length>0">
                  <el-select v-model="baseForm[index].cityNo" placeholder="请选择市" size="medium" style="width:160px" @change="selectCity($event,index)">
                    <el-option v-for="item in baseForm[index].citys" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="countyNo"  v-if="baseForm[index].countys.length>0">
                  <el-select v-model="baseForm[index].countyNo" placeholder="请选择县" size="medium" style="width:160px" @change="selectCounty($event,index)">
                    <el-option v-for="item in baseForm[index].countys" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-row>
          <el-form-item label="详细地址" prop="name">
            <el-input v-model="baseForm[index].startAddress"  @input="transData(index)" size="medium" style="width:100%;" type="text" :maxlength="num30" placeholder="详细地址不得少于2个字符" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
          </el-form-item>
          <el-row :gutter="5">
            <el-form-item label="目的地" required class="addr">
              <el-col :span="8">
                <el-form-item prop="provinceNo">
                  <el-select v-model="baseForm[index].provinceNo1" placeholder="请选择省份" size="medium" style="width:160px" @change="selectProvince1($event,index)" >
                    <el-option v-for="item in provinces" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="cityNo" v-if="baseForm[index].citys1.length>0">
                  <el-select v-model="baseForm[index].cityNo1" placeholder="请选择市" size="medium" style="width:160px" @change="selectCity1($event,index)">
                    <el-option v-for="item in baseForm[index].citys1" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="countyNo"  v-if="baseForm[index].countys1.length>0">
                  <el-select v-model="baseForm[index].countyNo1" placeholder="请选择县" size="medium" style="width:160px"  @change="selectCounty1($event,index)">
                    <el-option v-for="item in baseForm[index].countys1" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-row>
          <el-form-item label="详细地址" prop="name" >
            <el-input v-model="baseForm[index].stopAddress" @input="transData(index)" size="medium" style="width:100%;" type="text" :maxlength="num30" placeholder="详细地址不得少于2个字符" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
          </el-form-item>
          
        </el-form>
      </div>
    </div>
</template>


<script>
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
export default {
  name: "DriverComponent",
  props: {
    logistics: {
      type: Array,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pickerTimeOptions: {
        // 限制日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      num20: 20,
      num11: 11,
      num30: 30,
      citys: [],
      countys: [],
      citys1: [],
      countys1: [],
      driverKeyValue: [], //司机下拉框列表
      baseForm: [
        {
          name: "",
          leaderId: "", // 联系人
          phone: "",
          provinceNo: "", // 省份
          cityNo: "", // 城市
          countyNo: "", // 辖区
          provinceNo1: "", // 省份
          cityNo1: "", // 城市
          countyNo1: "", // 辖区
          address: "", // 详细地址-起始地
          detail: "", // 详细地址-目的地
          provinceName: "",
          cityName: "",
          countryName: "",
          provinceName1: "",
          cityName1: "",
          countryName1: "",
          startAddress: "",
          stopAddress: "",
          citys: [],
          countys: [],
          citys1: [],
          countys1: []
        }
      ],

      rules: {
        name: [
          {
            required: true,
            trigger: "blue"
          }
        ]
      },
      driverList: [
        {
          driverId: "",
          name: "",
          phone: "",
          carNo: "",
          driverNo: "",
          startDate: new Date(),
          endDate: new Date(),
          startAreaId: 0,
          startAddress: "",
          stopAreaId: 0,
          stopAddress: "",
          enterprise: ""
        }
      ]
      // initObj: this.logistics
    };
  },
  // watch: {
  //   logistics(value) {
  //     console.log(value);
  //     this.initData(value);
  //   }
  // },
  async mounted() {
    this.getDriverData();
    await this.getProvinces();
    this.initData();
  },
  computed: {
    ...mapState(modules.area, {
      provinces: "provinces"
    })
    // initObj() {
    //   // this.initData();
    //   return this.logistics;
    // }
  },
  methods: {
    ...mapActions(modules.driverManage, [
      "getDriverKeyValue", //获取司机商下拉框列表
      "getSingleDriver"
    ]),
    ...mapActions(modules.area, {
      getProvinces: "getProvinces",
      getArea: "getArea"
    }),
    async initData() {
      setTimeout(async () => {
        console.log(this.logistics);
        for (let i = 0; i < this.logistics.length; i++) {
          if (!this.baseForm[i]) {
            this.baseForm[i] = {};
          }
          this.baseForm[i].provinceNo = this.logistics[i].startProvinceId;
          this.baseForm[i].provinceName = this.provinces.find(item => {
            return item.id == this.baseForm[i].provinceNo;
          }).name;
          let obj = {
            parentNo: this.baseForm[i].provinceNo
          };
          let result = await this.getArea(obj);
          this.baseForm[i].citys = result;
          // await this.selectProvince(data[i].startProvinceId, i);
          this.baseForm[i].cityNo = this.logistics[i].startCityId;
          this.baseForm[i].cityName = this.baseForm[i].citys.find(item => {
            return item.id == this.baseForm[i].cityNo;
          }).name;
          // await this.selectCity(data[i].startCityId, i);
          let obj1 = {
            parentNo: this.baseForm[i].cityNo
          };
          let result1 = await this.getArea(obj1);
          this.baseForm[i].countys = result1;
          this.baseForm[i].countyNo = this.logistics[i].startCountyId;
          this.baseForm[i].countryName = this.baseForm[i].countys.find(item => {
            return item.id == this.baseForm[i].countyNo;
          }).name;
          let addr = this.logistics[i].startAddress.split("/");
          this.baseForm[i].startAddress = addr[1];
          await this.endAddr(this.logistics, i);
          this.transData(i);
        }
      }, 1000);
      console.log(456);
    },
    async endAddr(data, i) {
      this.baseForm[i].provinceNo1 = data[i].stopProvinceId;
      this.baseForm[i].provinceName1 = this.provinces.find(item => {
        return item.id == this.baseForm[i].provinceNo1;
      }).name;
      let obj = {
        parentNo: this.baseForm[i].provinceNo1
      };
      let result = await this.getArea(obj);
      this.baseForm[i].citys1 = result;
      // await this.selectProvince(data[i].startProvinceId, i);
      this.baseForm[i].cityNo1 = data[i].stopCityId;
      this.baseForm[i].cityName1 = this.baseForm[i].citys1.find(item => {
        return item.id == this.baseForm[i].cityNo1;
      }).name;
      // await this.selectCity(data[i].startCityId, i);
      let obj1 = {
        parentNo: this.baseForm[i].cityNo1
      };
      let result1 = await this.getArea(obj1);
      this.baseForm[i].countys1 = result1;
      this.baseForm[i].countyNo1 = data[i].stopCountyId;
      this.baseForm[i].countryName1 = this.baseForm[i].countys1.find(item => {
        return item.id == this.baseForm[i].countyNo1;
      }).name;
      let addr = data[i].stopAddress.split("/");
      this.baseForm[i].stopAddress = addr[1];
    },
    transData(index) {
      let params = {
        enterprise: this.logistics[index].enterprise,
        driverId: this.logistics[index].driverId,
        name: this.logistics[index].name,
        phone: this.logistics[index].phone,
        carNo: this.logistics[index].carNo,
        driverNo: this.logistics[index].driverNo,
        startDate: this.logistics[index].startDate,
        endDate: this.logistics[index].endDate,
        startAreaId:
          this.baseForm[index].countyNo ||
          this.baseForm[index].cityNo ||
          this.baseForm[index].provinceNo,
        startAddress:
          this.baseForm[index].provinceName +
          this.baseForm[index].cityName +
          this.baseForm[index].countryName +
          "/" +
          this.baseForm[index].startAddress,
        stopAreaId:
          this.baseForm[index].countyNo1 ||
          this.baseForm[index].cityNo1 ||
          this.baseForm[index].provinceNo1,
        stopAddress:
          this.baseForm[index].provinceName1 +
          this.baseForm[index].cityName1 +
          this.baseForm[index].countryName1 +
          "/" +
          this.baseForm[index].stopAddress,
        startProvinceId: this.baseForm[index].provinceNo,
        startCountyId: this.baseForm[index].countyNo,
        startCityId: this.baseForm[index].cityNo,
        stopProvinceId: this.baseForm[index].provinceNo1,
        stopCountyId: this.baseForm[index].countyNo1,
        stopCityId: this.baseForm[index].cityNo1,
        baseList: this.baseForm[index]
      };

      this.logistics.splice(index, 1, params);
    },
    //省份获取之后 获取对应的城市---起始地
    async selectProvince(e, index) {
      this.baseForm[index].provinceName = this.provinces.find(item => {
        return item.id == e;
      }).name;
      let obj = {
        parentNo: this.baseForm[index].provinceNo
      };
      let result = await this.getArea(obj);
      this.baseForm[index].citys = result;
      this.baseForm[index].cityNo = null;
      this.baseForm[index].countyNo = null;
      this.baseForm[index].countys = [];
      this.baseForm[index].countryName = "";
      this.baseForm[index].cityName = "";
      let params = this.transData(index);
    },
    // 城市获取之后 获取对应的县市-起始地
    async selectCity(e, index) {
      this.baseForm[index].cityName = this.baseForm[index].citys.find(item => {
        return item.id == e;
      }).name;
      let obj = {
        parentNo: this.baseForm[index].cityNo
      };
      let result = await this.getArea(obj);
      this.baseForm[index].countys = result;
      this.baseForm[index].countyNo = null;
      this.baseForm[index].countryName = "";
      let params = this.transData(index);
    },
    selectCounty(e, index) {
      this.baseForm[index].countryName = this.baseForm[index].countys.find(
        item => {
          return item.id == e;
        }
      ).name;
      let params = this.transData(index);
    },
    //省份获取之后 获取对应的城市---目的地
    async selectProvince1(e, index) {
      this.baseForm[index].provinceName1 = this.provinces.find(item => {
        return item.id == e;
      }).name;
      let obj = {
        parentNo: this.baseForm[index].provinceNo1
      };
      let result = await this.getArea(obj);
      this.baseForm[index].citys1 = result;
      this.baseForm[index].cityNo1 = null;
      this.baseForm[index].countyNo1 = null;
      this.baseForm[index].countys1 = [];
      let params = this.transData(index);
    },
    // 城市获取之后 获取对应的县市-目的地
    async selectCity1(e, index) {
      this.baseForm[index].cityName1 = this.baseForm[index].citys1.find(
        item => {
          return item.id == e;
        }
      ).name;
      let obj = {
        parentNo: this.baseForm[index].cityNo1
      };
      let result = await this.getArea(obj);
      this.baseForm[index].countys1 = result;
      this.baseForm[index].countryName1 = "";
      this.baseForm[index].countyNo1 = null;
      let params = this.transData(index);
    },
    selectCounty1(e, index) {
      this.baseForm[index].countryName1 = this.baseForm[index].countys1.find(
        item => {
          return item.id == e;
        }
      ).name;
      let params = this.transData(index);
    },
    // 获取司机keyValue
    getDriverData() {
      this.getDriverKeyValue()
        .then(rsp => {
          this.driverKeyValue = rsp;
        })
        .catch(err => {
          console.dir(err);
        });
    },
    changeDriver(e, index) {
      this.getSingleDriver(e).then(data => {
        // this.logistics.splice(index, 1, data);
        this.logistics[index].driverId = data.id;
        this.logistics[index].name = data.name;
        this.logistics[index].phone = data.phone;
        this.logistics[index].carNo = data.carNo;
        this.logistics[index].driverNo = data.driverNo;
        this.logistics[index].enterprise = data.enterprise;
        let params = this.transData(index);
      });
    },
    // 添加流通商信息
    add(name) {
      this.baseForm.push({
        name: "",
        leaderId: "", // 联系人
        phone: "",
        provinceNo: "", // 省份
        cityNo: "", // 城市
        countyNo: "", // 辖区
        provinceNo1: "", // 省份
        cityNo1: "", // 城市
        countyNo1: "", // 辖区
        address: "", // 详细地址-起始地
        detail: "", // 详细地址-目的地
        provinceName: "",
        cityName: "",
        countryName: "",
        provinceName1: "",
        cityName1: "",
        countryName1: "",
        startAddress: "",
        stopAddress: "",
        citys: [],
        countys: [],
        citys1: [],
        countys1: [],
        baseList: ""
      });
      this.logistics.push({
        driverId: "",
        name: "",
        phone: "",
        carNo: "",
        driverNo: "",
        startDate: "",
        endDate: "",
        startAreaId: "",
        startAddress: "",
        stopAreaId: "",
        stopAddress: "",
        enterprise: ""
      });
      this.$nextTick(() => {
        let i = this.logistics.length - 1;
        window.location.href = `#driver${i}`;
      });
    },
    // 删除 流通商信息
    del(name, index) {
      this.baseForm.splice(index, 1);
      this.logistics.splice(index, 1);
    }
  }
};
</script>

<style lang="stylus">
.driver-component
  .time
    .el-input__inner
      height 44px;
      line-height 44px;
  .txc
    .el-form-item__label
      text-align:center;
      padding: 0 5px 0 0;
  textarea
    font-size:14px;
    font-family:MicrosoftYaHeiUI;
    font-weight:400;
    color:rgba(51,51,51,1);
    min-height:180px !important;
    width: 500px !important
  .two-row
    display flex;
    .el-form-item
      width:300px;
  .content-form-container
    background #f2f3f6
  .el-form-item 
    width 600px;
  .el-input--medium .el-input__inner
    line-height 44px;
    height:44px;
  
</style>
<style lang="stylus" scoped>
  .el-form{
    border-top:1px solid #eee!important;
  }
  .main-container-form
    overflow:hidden;
    margin-bottom:10px;
    border:1px solid #e0e0e0;
    background #fff
  .el-form
    position relative
    padding: 28px 0 40px 150px
  .head-title
    line-height:48px;
    font-size:16px;
    background #f7f7f7;
    .titleForm-container
      float left;
      height:48px;
      line-height:48px;
      font-weight: initial;
    .add
      float right;
      margin-right:95px;
      color:#3389FF
      cursor:pointer;
      img 
        margin-right:7px;
        vertical-align: middle;
      span 
        vertical-align: middle;
  .delete
    position absolute;
    right: 85px;
    top:28px;
    width:80px;
    border-radius:4px;
    line-height:36px;
    text-align:center;
    color:#fefefe;
    cursor:pointer;
    background:#E23A0D
  .save-cancel
    padding:20px 0 40px 0;
</style>
